import '../../../polyfills';
import WebpackerReact from 'webpacker-react';

import { ProductBucket } from '../../../ProductBucket';
import { ProductShareLinks } from '../../../ProductShow';
import CollectionDownloadModal from '../../../CollectionDownloadModal';

WebpackerReact.setup({
  ProductBucket,
  ProductShareLinks,
  CollectionDownloadModal,
});
